import * as React from 'react';

import {ActionCard} from 'shells/action-card/action-card';
import {PlayRoundedIcon} from 'shells/icon/svg/play-rounded-icon';
import {Body} from 'shells/typography/body';

import type {
    GetActivityForModal_activity as Activity,
    GetActivityForModal_activity_logNote_audioLog as AudioLog,
} from 'nutshell-graphql-types';

import {useActivityRecordingDelete} from '../../graphql/hooks';

import {CONFIRMATION_QUESTION} from './consts';

import styles from './recordings.module.css';

type Props = {
    activity: Activity;
    audioLog: AudioLog;
};

export function Audio(props: Props) {
    const {activity, audioLog} = props;

    const [audioPlaying, setAudioPlaying] = React.useState<boolean>(false);

    const {activityRecordingDelete} = useActivityRecordingDelete();

    const handleRemoveAudio = () => {
        activityRecordingDelete({
            activity: activity.id,
            recordingFileId: audioLog.fileId,
        });
    };

    const handlePlayAudio = () => {
        setAudioPlaying(true);
    };

    const audioUrl = audioLog.href;

    return (
        <>
            {audioPlaying ? (
                <audio
                    controls={true}
                    autoPlay={true}
                    src={audioUrl}
                    // @ts-expect-error
                    type='audio/mp3'
                    className={styles['audio-player']}
                >
                    <Body>Your browser does not support this audio.</Body>
                </audio>
            ) : (
                <ActionCard
                    actionTitle='Listen to audio'
                    actionIcon={PlayRoundedIcon}
                    onAction={handlePlayAudio}
                    onRemove={handleRemoveAudio}
                    closeButtonTooltip='Remove'
                    confirmationQuestion={CONFIRMATION_QUESTION}
                />
            )}
        </>
    );
}
